<template>
   <div v-bind:class="'products-wrapper ' + view" v-if="rows.length" :class="[ $route.name === 'Dashboard' ? 'side-panel' : 'test' ]">
    <span class="shadow shadow-left"></span>
    <div class="table-responsive">
      <div v-bind:class="'products ' + view">

        <!-- rows render -->
        <div v-bind:class="'products-view ' + view">


          <!-- Header
          <div v-bind:class="'product-columns product-header-row' + (view === 'grid-view' ? 'd-none' : '')" > -->
<div
  :class="[
    'product-columns product-header-row',
    { 'd-none': view === 'grid-view', '': $route.name === 'Dashboard' }
  ]"
>
            <div class="column-name header-column"
                 v-if="icons.length"
            >
              {{ t('tbl_header_icons') }}
            </div>
            <div class="column-name header-column"
                 v-if="images.length"
            >
              {{ t('tbl_header_images') }}
            </div>
            <div class="column-name header-column"
                 v-if="buttons.length"
            >
              {{ t('tbl_header_buttons') }}
            </div>
            <div
              v-for="column in columns"
              :class="['column-name', 'header-column', ((column.FieldType === 'INPUTBOX' && column.DataType === 'MONEY') || (column.FieldType === 'INPUTBOX' && (column.DataType === 'DECIMAL2' || column.DataType === 'DECIMAL3' || column.DataType === 'DECIMAL4' || column.DataType === 'DECIMAL0' || column.DataType === 'DECIMAL99')) ? 'number-format' : '')]"
            >
              {{ t(column.Label) }}
            </div>
            <div
              v-if="forms.length"
              class="column-name header-column"
            >
              <template v-for="formElement in forms">
                {{ t(formElement.Label) }}
              </template>
            </div>
          </div>



          <div
            v-for="row in rows"
            class="product-columns"
            v-bind:class="[_isSuccessRow(row) ? 'success-row' : '',_isLastRow(row) ? 'last-row' : '', animation ? (view ==='grid-view' ? 'animation-scale-up' : 'animation-fade') : null]"
            :style="[animation ? (view ==='grid-view' ? 'animation-fill-mode: backwards; animation-duration: 250ms; animation-delay: 50ms;' : '') : null]"
            :data-id="row.ID"
            :data-title="row.SEARCHTEXT"
            :data-duration="row.DURATIONSCHED"
             @click="_clickListener(row)"
          >





  <div v-if="row.CODE && view === 'grid-view'"
     class="card-header repnode-card-header pb-1 mb-2"
      @click="_clickListener(row)">

    <div class="font-weight-bold fs-18">{{ row.CODE }}</div>
    <div class="">{{ row.ADDRESSNAME }}</div>
   <div v-if="row.STTASKSTATUS" class="badge badge-primary">{{ row.STTASKSTATUS }}</div>

    <div v-for="(subHeader, index) in subHeaders" :key="index">
        <icons-render v-if="subHeader instanceof Object" :propIcons="[{
            def: {},
            value: subHeader
        }]"/>
        <span v-else>{{ subHeader }}</span>
    </div>
</div>

<div v-else-if="row.SEARCHTEXT && view === 'grid-view'"
     class="card-header repnode-card-header"
      @click="_clickListener(row)">

    {{ row.SEARCHTEXT }}
</div>


          <div class="column-name"
                 @click="_clickListener(row)"
                 v-if="icons.length"
            >
              <icons-render :propIcons="_preprocessIconImageData(row, icons)"/>
            </div>
            <div class="column-name"
                 @click="_clickListener(row)"
                 v-if="images.length"
            >
              <images-render :propImages="_preprocessIconImageData(row, images)"/>
            </div>

            <div class="column-name"
                 @click="_clickListener(row)"
                 v-if="buttons.length"
            >
              <template v-for="column in buttons" v-if="column.FieldType === 'ENUBUTTON'">
                <form-action-button
                  :def="def"
                  :buttonsDef="[column]"
                  :data="row"
                  :updateDataRequest="updateDataRequest"
                  :formDataChanged="formDataChanged"
                />
              </template>
            </div>

            <template v-for="(column, index) in columns">
              <div class="row-title">
                {{ t(column.Label) }}
              </div>
              <div
                @click="_clickListener(row)"
                :class="['column-name', (index === 0 ? 'first' : '')]"
              >
                <span class="grid-sub-icons">
                  <icons-render v-if="column.Fields" :propIcons="_preprocessIconImageData(row, column.Fields)"/>
                </span>

                <span v-if="column.DataType === 'NVARCHAR' || column.DataType === 'TEXT'"
                      v-html="row[column.ColumnName]"
                      class="content-grid-unit"
                ></span>
                <span v-if="column.FieldType !== 'DOCUMENT' && (column.DataType === 'INT' || column.DataType === 'SMALLINT')"
                      v-html="_preprocessInt(row, column)"
                      class="content-grid-unit"
                ></span>
                <span v-if="column.DataType === 'DATETIME' || column.DataType === 'DATETIMEINPUT'"
                      v-html="_preprocessDatetime(row[column.ColumnName], column)"
                      class="content-grid-unit"
                ></span>
                <span v-if="column.DataType === 'DATE'"
                      v-html="_preprocessDate(row[column.ColumnName], column)"
                      class="content-grid-unit"
                ></span>
                <span
                  v-if="column.FieldType === 'INPUTBOX' && (column.DataType === 'DECIMAL2' || column.DataType === 'DECIMAL3' || column.DataType === 'DECIMAL4' || column.DataType === 'DECIMAL0' || column.DataType === 'DECIMAL99')"
                  v-html="_preprocessDecimals(row[column.ColumnName], column)"
                  class="content-grid-unit number-format"
                ></span>
                <span
                  v-if="column.FieldType === 'INPUTBOX' && column.DataType === 'MONEY'"
                  v-html="_preprocessMoney(row[column.ColumnName], column)"
                  class="content-grid-unit number-format"
                ></span>
                <span
                  v-if="dataTypesHelper.isDocumentImage(column)"
                  class="content-grid-unit"
                >
                <img :ref="'document-image-' + row.ID" style="display: none"/>
              </span>
                <template v-if="_getColumnButtons(column).length" v-for="button in _getColumnButtons(column)">
                  <form-action-button
                    :def="def"
                    :buttonsDef="[button]"
                    :data="row"
                    :updateDataRequest="updateDataRequest"
                    :formDataChanged="formDataChanged"
                  />
                </template>
              </div>
            </template>

            <grid-form
              @buttonClicked="formButtonClicked"
              :rowData="row"
              :def="def"
              :formDefs="forms"
              :updateDataRequest="updateDataRequest"
            />

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import PDELinkGenerator              from '../../../model/wrapper/pde-link-params'
import IconsRender                   from '../../templates/widgets/icons-render'
import ImagesRender                  from '../../templates/widgets/images-render'
import GridForm                      from './grid-form/grid-form'
import SessionStorage                from '../../../model/storage/session-storage'
import Definition                    from '../../../model/entity/Definition'
import { DataTypesHelper }           from '../../../model/data-types-helper'
import { DocumentImagePreprocessor } from '../../../model/preprocessor/document-image-preprocessor'
import DatetimeParser                from '../../../model/parser/datetime-parser'
import FormActionButton              from '../../widgets/forms/form-action-button'
import FormElementTypes              from '../../../model/FormElementTypes'

export default {
  components: {
    FormActionButton,
    IconsRender,
    ImagesRender,
    GridForm
  },
  props:      {
    def:               {
      type:    Definition,
      default: function () {
        return null
      }
    },
    rows:              {
      type:    Array,
      default: function () {
        return []
      }
    },
    backRedirect:      {
      type:    String,
      default: 'grid'
    },
    parentData:        {
      type:    Object,
      default: function () {
        return null
      }
    },
    urlParentDataProp: {
      type:    String,
      default: function () {
        return null
      }
    },
    view:              {
      type:    String,
      default: ''
    },
    animation:         {
      type:    Boolean,
      default: false
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    rowClickEmit:      {
      type:    Boolean,
      default: false
    }
  },

  data () {
    return {
      columns:        [],
      icons:          [],
      images:         [],
      forms:          [],
      query:          null,
      documentImages: [1, 2],
      subHeaders:     [],  // Define subHeaders here

      dataTypesHelper:           DataTypesHelper,
      documentImagePreprocessor: DocumentImagePreprocessor
    }
  },

  created () {
    this._initBase()
  },

  updated () {
    this._postprocessRows()
  },

  watch: {
    'def': function () {
      this._initBase()
    }
  },

  computed: {
    urlParentData: {
      get: function () {
        return this.urlParentDataProp ? JSON.parse(this.urlParentDataProp) : null
      }
    },

    getHeaderField(){
      const isHeader = this.columns.find((column)=>{
        return column.Layout === 'Header'}
      );

      return isHeader && isHeader.Field
    }
  },

  methods: {

    /**
     *
     * @private
     */
    _initBase () {
      this.columns = this.def.filteredGrid
      this.forms   = this.def.listForms
      this.icons   = this.def.listIcons
      this.images  = this.def.listImages
      this.buttons = this.def.listButtons
      this.subHeaders = []
    },

    /**
     *
     * @private
     */
    _postprocessRows () {
      this.def.listDocuments.forEach((documentDefinition) => {
        if (this.dataTypesHelper.isDocumentImage(documentDefinition)) {
          this.rows.forEach((row) => {
            let callback = (src) => {
              let elm = $(this.$refs['document-image-' + row.ID])
              elm.attr('src', src)
              elm.show()
            }

            this.documentImagePreprocessor.preprocess(documentDefinition, row, callback)
          })
        }
      })
    },

    /**
     *
     * @param row
     * @param defs
     */
    _preprocessIconImageData (row, defs) {
      let output = []

      defs.forEach(function (item) {
        if (!row.hasOwnProperty(item.ColumnName)) {
          return
        }

        output.push({
          value:     JSON.parse(row[item.ColumnName]),
          extension: row['FILEEXTENSION'] ? row['FILEEXTENSION'].replace('.', '') : '',
          def:       item
        })
      })

      return output
    },

    /**
     *
     * @param value
     * @param columnSpec
     * @private
     */
    _preprocessDatetime (value, columnSpec) {
      if (!value) {
        return ''
      }

      let parseEndDateRealDate = DatetimeParser.parseDate(value),
          parseEndDateRealTime = DatetimeParser.parseTime(value)

      return parseEndDateRealDate + ' ' + parseEndDateRealTime
    },

    /**
     *
     * @param value
     * @param columnSpec
     * @private
     */
    _preprocessDate (value, columnSpec) {
      if (!value) {
        return ''
      }

      return DatetimeParser.parseDate(value)
    },

    /**
     *
     * @param value
     * @param columnSpec
     * @private
     */
    _preprocessDecimals (value, columnSpec) {
      if (value ===  null || value === undefined) {
        return ''
      }

      if (columnSpec.DataType.includes('99')) {
        return value
      }

      let dec = parseInt(columnSpec.DataType.slice(-1))

      return value.format(dec, 3, ' ', ',')
    },

    /**
     *
     * @param value
     * @param columnSpec
     * @private
     */
    _preprocessMoney (value, columnSpec) {
      if (value === null || value === undefined) {
        return ''
      }

      return value.format(2, 3, ' ', ',')
    },

    /**
     *
     * @param row
     * @param column
     * @private
     */
    _preprocessInt (row, column) {
      const value = row[column.FieldViewed]
      if (value) {
        return value
      }

      return row[column.ColumnName]
    },

    /**
     *
     * @param row
     * @private
     */
    _clickListener (row) {
      if (this.rowClickEmit) {
        this.$emit('rowClick', row)
        return
      }

      if (!this.def.editor.length) {
        return
      }

      SessionStorage.setArrayItem(SessionStorage.GRID_LAST_ROW, { key: this.def.field, row: row })

      PDELinkGenerator.defaults = row
      PDELinkGenerator.redir    = this.backRedirect

      if (this.parentData) {
        let parent = {
          id:           this.$route.params.id,
          page:         this.$route.params.page,
          idEStructure: this.$route.params.idStructure,
          label:        this.parentData.data.SEARCHTEXT,
          urlHash:      window.location.hash,
          parent:       JSON.stringify(this.urlParentData)
        }

        const parentData = this.urlParentData ? this.urlParentData : []

        parentData.push(parent)

        PDELinkGenerator.parent    = JSON.stringify(parentData)
        PDELinkGenerator.parentDef = this.parentData.def
      }

      this.$router.push(PDELinkGenerator.getParams(this.def))
    },

    /**
     *
     * @param row
     * @private
     * @return boolean
     */
    _isLastRow (row) {
      const lastData = SessionStorage.getArrayItem(SessionStorage.GRID_LAST_ROW, this.def.field)

      return (row.hasOwnProperty('ID')) && (lastData && lastData.row.hasOwnProperty('ID')) && (row.ID === lastData.row.ID)
    },

    /**
     *
     * @param row
     * @private
     * @return boolean
     */
    _isSuccessRow (row) {
      const successData = SessionStorage.getArrayItem(SessionStorage.GRID_SUCCESS_ROW, this.def.field)
      const result      = (row.hasOwnProperty('ID')) && (successData && successData.row.hasOwnProperty('ID')) &&
        (row.ID === successData.row.ID)

      if (result) {
        SessionStorage.clearArray(SessionStorage.GRID_SUCCESS_ROW, this.def.field)
      }

      return result
    },

    /**
     *
     * @param columnDef
     * @private
     */
    _getColumnButtons (columnDef) {
      const buttons = []
      if (!columnDef.hasOwnProperty('Fields') || !columnDef.Fields.length) {
        return buttons
      }

      columnDef.Fields.forEach((item) => {
        if (item.FieldType === FormElementTypes.enuFormAction) {
          buttons.push(item)
        }
      })

      return buttons
    },

    formButtonClicked () {
      this.$emit('formButtonClicked')
    }
  }

}
</script>

<style scoped>
.grid-view .column-name span {
  /*display: block;*/
}

.row-title {
  display: none;
  text-align: left;
  width: 100%;
  padding: 1px 15px;
  opacity: 0.6;
  font-size: 0.7rem;
}

.grid-view .row-title {
  display: flex;
}

</style>
